import { render } from "./productCourse.vue?vue&type=template&id=d5caf04c&ts=true"
import script from "./productCourse.vue?vue&type=script&lang=ts"
export * from "./productCourse.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__